"use strict";
exports.__esModule = true;
exports.iconCardsContainer = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../../types");
var fields_1 = require("../../../fields");
var iconCardsContainer = function (data, logger) {
    return utils_1.compact({
        type: types_1.FooterCardType.ICON,
        tiles: data === null || data === void 0 ? void 0 : data.items.map(function (item) {
            return utils_1.compact({
                title: logger.required(fields_1.toText(item === null || item === void 0 ? void 0 : item.title)),
                description: fields_1.toText(item === null || item === void 0 ? void 0 : item.description),
                icon: logger.required(fields_1.toIcon(item === null || item === void 0 ? void 0 : item.icon)),
                ctaLabel: logger.required(fields_1.toText(item === null || item === void 0 ? void 0 : item.ctaLabel)),
                ctaLink: logger.required(fields_1.toLink(item === null || item === void 0 ? void 0 : item.ctaLink, logger))
            });
        })
    });
};
exports.iconCardsContainer = iconCardsContainer;
//# sourceMappingURL=footer-icon-card.js.map